import { useState, useSyncExternalStore } from 'react'

import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

import {
  isSessionExpired,
  signInAgain,
  subscribeToSessionExpiry,
} from '@/services/AccessTokenService'
import '@/components/dialog-modal/DialogModal.scss'

function SessionExpiredDialog(): React.JSX.Element {
  const isExpired = useSyncExternalStore(subscribeToSessionExpiry, isSessionExpired)
  const [isSigningIn, setIsSigningIn] = useState(false)

  const handleSignIn = (): void => {
    setIsSigningIn(true)
    signInAgain()
      .catch((error) => console.error('Sign-in failed:', error))
      .finally(() => setIsSigningIn(false))
  }

  return (
    <Dialog
      className="dialog-container"
      PaperProps={{ style: { borderRadius: '8px' } }}
      open={isExpired}
      aria-labelledby="session-expired-title"
      aria-describedby="session-expired-description"
    >
      <div className="dialog-content">
        <DialogTitle id="session-expired-title" className="dialog-title">
          Session expired
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            component="div"
            id="session-expired-description"
            className="description-field"
          >
            Your sign-in has expired. Sign in again to keep working.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="confirm-btn-style" disabled={isSigningIn} onClick={handleSignIn}>
            Sign in
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  )
}

export default SessionExpiredDialog
